import { Component, Host, Prop, h } from '@stencil/core';

import bannerActions from '../../../actions/actions.interactive-banner';
import Logo from '../../../assets/logos/ICO_Dealer.svg';
import { trackBannerButtonClick } from '../../../tracking/tracking.interactiveBanner';
import { ACS_EVENT_PROPS } from '../../../utils/utils.asc-analytics';

@Component({
  tag: 'banner-maintenance-page',
  styleUrl: 'banner-maintenance-page.css',
  shadow: false,
})
export class BannerMaintenancePage {
  @Prop() showDesktop: boolean = false;

  render() {
    const bannerMaintenanceClass = {
      'flex mx-auto bg-clrs-kbb-airforceblue border-clrs-kbb-gold border-solid box-border rounded justify-evenly text-clrs-white font-open-sans relative cursor-pointer items-center':
        true,
      'flex-col': !this.showDesktop,
      'flex-row w-lg py-4': this.showDesktop,
    };
    const bannerMaintenanceTextClass = {
      'antialiased font-extrabold font-open-sans m-auto text-center text-clrs-white': true,
      'flex-col py-5': !this.showDesktop,
      'flex-row w-full box-border py-4 text-wwtbyc whitespace-normal': this.showDesktop,
    };
    const bannerMaintenanceButtonClass = {
      'w-full': !this.showDesktop,
      'w-48': this.showDesktop,
    };
    return (
      <Host
        onclick={() => {
          bannerActions.onBannerNextAction();
          trackBannerButtonClick(ACS_EVENT_PROPS.START_MY_OFFER);
        }}
        class={bannerMaintenanceClass}>
        <div class="py-5">
          <img src={Logo} title="KBB ICO Logo" class="w-60" />
        </div>
        <div class="text-center">
          <div>
            <h1 class={bannerMaintenanceTextClass}>We Want To Buy Your Car!</h1>
          </div>
          <div>Get a Kelley Blue Book Instant Cash Offer in minutes.</div>
        </div>
        <div class={bannerMaintenanceButtonClass}>
          <ico-button label="Start My Offer" buttonSize="xlarge" class="h-fmv" />
        </div>
      </Host>
    );
  }
}
